import { ProfileUser } from '@/types/authen';
import { CONSTANTS } from '@/utils/constants';
import { atom } from 'recoil';

export const PHAN_HE_STORAGE_KEY = 'phanHe';

function getPhanHeDefault() {
  if (typeof window === 'undefined') return CONSTANTS.PHAN_HE.BSC;
  return CONSTANTS.PHAN_HE.BSC;
}

export const profile = atom({
  key: 'profile',
  default: {} as ProfileUser,
});

export const phanHe = atom({
  key: 'phanHe',
  default: getPhanHeDefault(),
});
